<template>
  <div class="row">
    <div v-for="(data, id) in data" :key="id" class="col-6 d-flex">
      <div class="card card_grey flex-fill">
        <div class="sub_title_2">
          {{ data.metricName }} ({{ data.currency }})
        </div>
        <div class="data_text">
          {{ convertCurrency(data.value) }}
        </div>
        <div>
          <div
            class="d-inline-flex align-items-center mt-2"
            :class="
              data.achievementStatus == 'UP' ? 'badge_green' : 'badge_red'
            "
          >
            <IconSvg
              :color="data.achievementStatus == 'UP' ? 'green' : 'red'"
              :type="data.achievementStatus == 'UP' ? 'chart_up' : 'chart_down'"
            />
            <div
              class="data_detil"
              :class="
                data.achievementStatus == 'UP' ? 'text_green' : 'text_red'
              "
            >
              <span v-if="data.achievementStatus == 'UP'">+</span>
              <span v-else>-</span>
              {{ data.achievement }}%
            </div>
          </div>
          <div class="d-inline-flex align-items-center me-2 badge_green">
            <IconSvg
              :color="data.trendStatus == 'UP' ? 'green' : 'red'"
              :type="data.trendStatus == 'UP' ? 'arrow_up' : 'arrow_down'"
            />
            <div
              class="data_detil"
              :class="data.trendStatus == 'UP' ? 'text_green' : 'text_red'"
            >
              <span v-if="data.trendStatus == 'UP'">+</span>{{ data.trend }}%
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="col-6 d-flex">
      <div class="card card_grey flex-fill">
        <div class="sub_title_2">{{ data.name }} (IDR / employee)</div>
        <div class="data_text">
          {{ convertCurrency(data.employee_value) }}
        </div>
        <div class="d-flex mt-2">
          <div class="d-inline-flex align-items-center me-2 badge_green">
            <IconSvg
              :color="data.employee_trend_status == 'UP' ? 'green' : 'red'"
              :type="
                data.employee_trend_status == 'UP' ? 'arrow_up' : 'arrow_down'
              "
            />
            <div
              class="data_detil"
              :class="
                data.employee_trend_status == 'UP' ? 'text_green' : 'text_red'
              "
            >
              <span v-if="data.employee_trend_status == 'UP'">+</span
              >{{ data.employee_trend }}%
            </div>
          </div>
          <div
            class="d-inline-flex align-items-center"
            :class="
              data.employee_achievement_status == 'UP'
                ? 'badge_green'
                : 'badge_red'
            "
          >
            <IconSvg
              :color="
                data.employee_achievement_status == 'UP' ? 'green' : 'red'
              "
              :type="
                data.employee_achievement_status == 'UP'
                  ? 'chart_up'
                  : 'chart_down'
              "
            />
            <div
              class="data_detil"
              :class="
                data.employee_achievement_status == 'UP'
                  ? 'text_green'
                  : 'text_red'
              "
            >
              <span v-if="data.employee_achievement_status == 'UP'">+</span
              >{{ data.employee_achievement }}%
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import IconSvg from "@/components/IconSvg.vue";
import LegalService from "@/services/legal/legal";
import { currencyFormatNumberComma } from "@/utils/helper";
const apiLegal = LegalService.build();

export default {
  props: ["load", "data"],
  components: {
    IconSvg,
  },
  methods: {
    convertCurrency(x) {
      const str = x.toString();
      if (str.includes(".")) {
        const cnv = str.split(".")[0];
        let dotIndex = str.indexOf(".");
        const after = str.slice(dotIndex + 1);
        return currencyFormatNumberComma(cnv) + "." + after;
      } else {
        return currencyFormatNumberComma(str);
      }
    },
  },
};
</script>
